// Auto-generated by typewriter from C# model
export enum IcmIncidentStatus {
    Active = 0,
    Suppressed = 1,
    Mitigated = 2,
    Resolved = 3,
    Mitigating = 4,
    Holding = 5
}
